import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentTypesFilesComponent } from './document-types-files.component';
import { AddFilesComponent } from './add-files/add-files.component';
import { EditFilesComponent } from './edit-files/edit-files.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        DocumentTypesFilesComponent,
        AddFilesComponent,
        EditFilesComponent,
    ],
    imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
    exports: [DocumentTypesFilesComponent],
})
export class DocumentTypesFilesModule { }
